import React, { useImperativeHandle, forwardRef } from 'react';
import { createPortal } from 'react-dom';

import isBrowser from './helpers/isBrowser';
import useDialog, { handleOpenType } from './hooks/useDialog/useDialog';

// NOTE: When adding to this, make sure to update the dialogs in the dialogReducer.
export enum dialogs {
    invite = 'invite',
    contact = 'contact',
    demo = 'demo'
}
export interface handleOpenRef {
    handleOpen: handleOpenType
}

/**
 * Dialog component that shows and hides UI elements.
 */
const Dialog = forwardRef((_props, ref) => {
    const { handleOpen, handleClose, dialogState } = useDialog();

    const { Render, callback, data, status, selectorId } = dialogState;

    useImperativeHandle(ref, () => ({
        handleOpen
    }), [handleOpen]);

    const container = selectorId ? document.querySelector(selectorId) : null;

    if (Render && container && isBrowser()) {
        return createPortal(
            <Render
                data={data}
                callback={callback}
                status={status}
                onClose={handleClose}
                selector={selectorId}
            />,
            container
        );
    }

    return null;
});

export default Dialog;
